export const ModuleId = {
    APPLICATION: "APPLICATION",
    PERSONNEL: "PERSONNEL",
    WORK: "WORK",
    DECISION: "DECISION",
    CMS: "CMS",
    PROCESS: "PROCESS",
    OFFICIAL_DISPATCH: "OFFICIAL_DISPATCH",
    SALARY : "SALARY",
    ASSET:"ASSET"
}